import { SingleDateFilterValue } from '@app/core/list-view/helpers/parse-as-single-date-filter';
import { ListViewQueryParams } from '@app/core/list-view/types';
import { youtubeIntegrationGetBroadcasts } from '@mi-front/api-v2';
import { Paginated } from '@mi-front/core';
import { YoutubeBroadcast } from '../../../youtube-broadcast-types';
import { youtubeBroadcastsDateToApiParams } from '../filters/youtube-broadcasts-filters-config';

/**
 * Fetches YouTube broadcasts for a station and selected calendar day.
 */
export async function fetchYoutubeBroadcasts(
  stationId: string,
  params: ListViewQueryParams,
  timezone: string,
): Promise<Paginated<YoutubeBroadcast>> {
  const dateRange = youtubeBroadcastsDateToApiParams(
    params.filters?.targetDate as SingleDateFilterValue | null | undefined,
    timezone,
  );
  const from = dateRange?.from;
  const to = dateRange?.to;

  if (!from || !to) {
    return {
      results: [],
      metadata: {
        pageIndex: 0,
        pagesCount: 0,
        showCount: 0,
        totalCount: 0,
      },
    };
  }

  const response = await youtubeIntegrationGetBroadcasts(stationId, {
    from,
    to,
  });

  const broadcasts = response.data ?? [];

  return {
    results: broadcasts,
    metadata: {
      pageIndex: 0,
      pagesCount: 1,
      showCount: broadcasts.length,
      totalCount: broadcasts.length,
    },
  };
}
